module.exports = __webpack_public_path__ + "img/elantra-19.ed7d5531.png";